import InstallApp from './InstallApp'

export * from './InstallApp'
export default InstallApp
